import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index/index'
import login from '@/pages/login/login'
import update from '@/pages/update/update'
import product from '@/pages/product/product'
import notPage from '@/pages/404'
import agreement from '@/pages/agreement/agreement'

Vue.use(Router)
/* eslint-disable */
const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'index',
      meta: {
        requireAuth: true,
      },
      component: index
    },
    {
      path: '/login',
      name: 'login',

      component: login
    },
    {
      path: '/update',
      name: 'update',
      meta: {
        requireAuth: true,
      },
      component: update
    },
    {
      path: '/product',
      name: 'product',
      meta: {
        requireAuth: true,
      },
      component: product
    },
    {
      path: '*',
      name: 'notPage',
      meta: {
        requireAuth: true,
      },
      component: notPage
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement
    },

  ]
})

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(err => err)
// }

let token = window.localStorage.getItem('token')




router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    if (token) { // 通过vuex state获取当前的token是否存在
      next();
    } else {
      next({
        path: '/login',
      })
    }
  } else {
    next();
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js